import { render, staticRenderFns } from "./ProjectReadOnlyView.vue?vue&type=template&id=bd7345f2&scoped=true&"
import script from "./ProjectReadOnlyView.vue?vue&type=script&lang=js&"
export * from "./ProjectReadOnlyView.vue?vue&type=script&lang=js&"
import style0 from "./ProjectReadOnlyView.vue?vue&type=style&index=0&id=bd7345f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7345f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VLayout})
